export const currencyList = [
    { label: 'Любая', value: 'ALL' },
    { label: 'RUB - Российский рубль', value: 'RUB' },
    { label: 'USDT (BEP 20) - Tether BEP20', value: 'BEP20' }, // bep 20
    { label: 'USDT (ERC 20) - Tether ERC20', value: 'ERC20' }, // ERC20
    { label: 'USDT (TRC 20) - Tether TRC20', value: 'TRC20' }, // trc 20
    { label: 'USD - Доллар США', value: 'USD' },
    { label: 'EUR - Евро', value: 'EUR' },
    { label: 'KGS - Киргизский сом', value: 'KGS' },
    { label: 'TJS - Таджикский сомони', value: 'TJS' },
    { label: 'BYN - Белорусский рубль', value: 'BYN' },
    { label: 'GEL - Грузинский лари', value: 'GEL' },
    { label: 'AMD - Армянский драм', value: 'AMD' },
    { label: 'AZN - Азербайджанский манат', value: 'AZN' },
    { label: 'MDL - Молдавский лей', value: 'MDL' },
    { label: 'UZS - Узбекский сум', value: 'UZS' },
    { label: 'TMT - Туркменский манат', value: 'TMT' },
    { label: 'KZT - Казахстанский тенге', value: 'KZT' },
    { label: 'AED - Дирхам ОАЭ', value: 'AED' },
    { label: 'TRY - Турецкая лира', value: 'TRY' },
    { label: 'UAH - Украинская гривна', value: 'UAH' },
    { label: 'BTC - Bitcoin', value: 'BTC' }, // btc
    { label: 'BCH - Bitcoin Cash', value: 'BCH' },
    { label: 'XRP - Ripple', value: 'XRP' },
    { label: 'DOGE - Dogecoin', value: 'DOGE' },
    { label: 'TRX - TRON', value: 'TRX' },
    { label: 'BNB - BNB BEP20', value: 'BNB' },
    { label: 'SOL - Solana', value: 'SOL' },
    { label: 'TON - Toncoin', value: 'TON' },
    { label: 'ETH - Ethereum', value: 'ETH' },// eth
];